import React, { useState, useEffect } from 'react';
import { Row, Col, Table, Form, Button } from 'react-bootstrap';
import * as Common from '../../Common';
import Dialog from '../../Dialog';

function AD1TransactionComment(props) {
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [commentList, setCommentList] = useState([]);
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [remark, setRemark] = useState('');

    useEffect(() => {
        if (props.rc !== refreshCounter) {
            setOnceRun(false);
        }
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiAD1Comment, [sid, 'list', props.srno], function (result) {
                setCommentList(JSON.parse(result));
            });
            setOnceRun(true);
        }
        setRefreshCounter(props.rc);
    }, [onceRun, sid, props, refreshCounter]);
    //add comment btn handler
    const btnAddComment = () => {
        if (remark.trim() === '') {
            setMsgText('Please enter comment remark');
            setMsgBox(true);
            return;
        }
        const obj = {
            srno: props.srno,
            cmnt: remark
        }
        Common.callApi(Common.apiAD1Comment, [sid, 'addcomment', JSON.stringify(obj)], function (result) {
            const res = JSON.parse(result);
            if (res.status) {
                setMsgText(res.msg);
                setRemark('');
                setMsgBox(true);
                setCommentList(res.data);
            }else{
                setMsgText(res.msg);
                setMsgBox(true);
            }
        });
    }

    return (
        <>
            {/* {props.srcMode */}
                <Row>
                    <Col xs={6}>
                        <Form.Group >
                            <Form.Label>Comment</Form.Label>
                            <Form.Control type="text" placeholder="Comment" maxLength={100}
                                onChange={(e) => Common.validateAlpNumValue(e.target.value, setRemark)}
                                value={remark} autoComplete="off" />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group >
                            <Form.Label>&nbsp;</Form.Label><br></br>
                            <Button variant="outline-success" size="sm" onClick={(e) => btnAddComment()} >Add Comment</Button>&nbsp;
                        </Form.Group>
                    </Col>
                </Row>
            {/* } */}
            <Row>
                <Col>
                    <h5>Comments</h5>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive >
                        <thead>
                            <tr>
                                <td>Time Stamp</td>
                                <td>User</td>
                                <td>Remark</td>
                            </tr>
                        </thead>
                        <tbody>
                            {commentList?.map((res,index) =>
                                <tr key={index}>
                                    <td>{(res.atrc_createddate)}</td>
                                    <td>{res.um_userName}</td>
                                    <td>{res.atrc_desc}</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
        </>
    )
}
export default AD1TransactionComment;